import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrl: "./alert.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AlertComponent {
  /**
   * The full classname of the font awesome icon.
   */
  readonly icon = input<string>("fa-circle-info");
  readonly summary = input.required<string>();
  readonly detail = input<string>();
  readonly severity = input<AlertSeverity>(AlertSeverity.PRIMARY);
  
  protected readonly severityClass = computed(
    () => ["alert", this.severity()].join("-")
  );
}

export enum AlertSeverity {
  PRIMARY = "primary",
  SECONARY = "secondary",
  SUCCES = "success",
  DANGER = "danger",
  WARNING = "warning",
  INFO = "info",
  LIGHT = "light",
  DARK = "dark"
}
